module.exports = __webpack_public_path__ + "img/16.ded9b146.jpg";